import { IconDownload } from '@tabler/icons-react'
import { StudyTextItem } from '@/types/studyText.type'
import { PagingInfo } from '@/types/user'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'
import { FormatFullDateTimeWithAMPM } from '@/utils/time'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import TablePaginate from '@/components/ui/table-paginate'

const StudyTextTable = ({
  meta,
  data,
  page,
  handlePageChange,
}: {
  meta: PagingInfo
  data: StudyTextItem[]
  page: number
  handlePageChange: (page: number) => void
}) => {
  const collumns = [
    { title: 'Files', width: 100 },
    { title: 'Uploaded At', width: '20%' },
    { title: 'Download', width: '10%' },
  ]

  const handleDownload = async (studyTextItem: StudyTextItem) => {
    try {
      const url = studyTextItem?.link
      if (url) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.download = studyTextItem?.link
          ? (studyTextItem?.link.split(/[\\/]/).pop() as string)
          : 'file'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return
      }
    } catch {
      toast.error('Failed to download file')
    }
  }

  return (
    <div>
      <Table>
        <TableHeader className='bg-[#F6F7F9]'>
          <TableRow>
            {collumns.map((item, index: number) => (
              <TableHead
                key={item.title}
                style={{ width: item.width }}
                className={cn(
                  'font-bold text-[#002652]',
                  index === 1 && 'text-center'
                )}
              >
                {item.title}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody className='text-[#002652]'>
          {data?.length === 0 && (
            <TableRow>
              <TableCell colSpan={8} className='h-24 text-center'>
                No data found.
              </TableCell>
            </TableRow>
          )}
          {data.map((item: StudyTextItem) => (
            <TableRow key={item.study_text_id}>
              <TableCell>{item.file_name}</TableCell>
              <TableCell className='text-center'>
                {FormatFullDateTimeWithAMPM(item.created_at)}
              </TableCell>
              <TableCell>
                <button
                  onClick={() => handleDownload(item)}
                  className='rounded p-2 hover:bg-[#daeefc]'
                >
                  <IconDownload />
                </button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {meta?.total_pages > 1 && (
        <div className='flex justify-end p-4'>
          <TablePaginate
            itemPerPage={meta.items_per_page}
            totalItems={meta.total_items}
            page={page}
            totalPages={meta?.total_pages}
            onPageChange={handlePageChange}
            readOnlyPageDisplay={false}
            hideOnSinglePage={false}
          />
        </div>
      )}
    </div>
  )
}

export default StudyTextTable
